import React, { Component } from "react";
import { Upload } from "antd";
import {
  uploadEmployeeData,
  saveEmployeeData,
} from "../redux/actions/formActions";
import {
  previousStep,
  showLoader,
  hideLoader,
} from "../redux/actions/miscActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Papa from "papaparse";
import GradProcesBar from "./utils/GradProcesBar";

const { Dragger } = Upload;

export class UploadEmployeeData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      filename: false,
    };
  }

  handleFileUpload = (info) => {
    const file = info.file.originFileObj;
    this.setState({
      filename: file.name,
    });
    Papa.parse(file, {
      header: true,
      download: true,
      complete: (results) => {
        const data = results.data;

        for (let index = data.length - 1; index >= 0; index--) {
          if (data[index].pers_nummer == "") {
            data.pop();
          }
        }
        setTimeout(() => {
          this.props.saveEmployeeData(results.data);
        }, 500);
      },
    });
  };

  handleRemoveFile = () => {
    this.setState({
      filename: false,
    });
    this.props.saveEmployeeData();
  };

  handlePrev = () => {
    const employeeData = this.state.data;
    this.props.saveEmployeeData(employeeData);
    this.props.previousStep();
  };

  componentWillUnmount = () => {
    this.props.hideLoader();
  };

  handleSubmit = () => {
    this.props.showLoader();

    const {
      companyInformation,
      taxCalcData,
      employeeData,
    } = this.props.formData;

    const {
      forfait,
      taxFreeSum,
      heffingskorting,
      sc1min,
      sc1max,
      sc1per,
      sc2min,
      sc2max,
      sc2per,
      sc3min,
      sc3max,
      sc3per,
      sc4min,
      sc4max,
      sc4per,
      sc5min,
      sc5max,
      sc5per,
    } = taxCalcData;

    let taxCalculationInput = {
      forfait,
      taxFreeSum,
      heffingskorting,
    };

    let schalen = [
      [sc1min, sc1max, sc1per],
      [sc2min, sc2max, sc2per],
      [sc3min, sc3max, sc3per],
      [sc4min, sc4max, sc4per],
      [sc5min, null, sc5per],
    ];

    setTimeout(() => {
      this.props.uploadEmployeeData(
        companyInformation,
        taxCalculationInput,
        schalen,
        employeeData,
        this.props.history
      );
    }, 0);
  };

  render() {
    const { filename } = this.state;
    const { isLoaderVisibile } = this.props.misc;
    return (
      <div className="upload-employee-data">
        <Dragger multiple={false} onChange={this.handleFileUpload}>
          <i className="fas fa-file-csv"></i>
          <p>Upload uw .csv bestand</p>
        </Dragger>
        {filename ? (
          <div className="upload-label">
            <i className="fas fa-paperclip"></i>
            <p>{filename}</p>
            <i
              className="fas fa-times-circle"
              onClick={this.handleRemoveFile}
            ></i>
          </div>
        ) : null}
        {isLoaderVisibile ? <GradProcesBar /> : null}
        <div className="buttons">
          <button className="prev-button" onClick={this.handlePrev}>
            <i className="fas fa-angle-left"></i> Previous
          </button>
          <button className="submit-button" onClick={this.handleSubmit}>
            Verwerk Loonstroken
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.formData,
  misc: state.misc,
});

export default connect(mapStateToProps, {
  uploadEmployeeData,
  saveEmployeeData,
  previousStep,
  showLoader,
  hideLoader,
})(withRouter(UploadEmployeeData));
